import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { EstadoPlanilla } from 'src/app/Models/planilla/estado-planilla';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-estado-planilla',
  templateUrl: './estado-planilla.component.html',
  styleUrls: ['./estado-planilla.component.css']
})
export class EstadoPlanillaComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public search    = '';
  public page: any;
  public total     = 0;
  public items: EstadoPlanilla[] = [];
  public nuevo: EstadoPlanilla   = new EstadoPlanilla();
  public agregando               = false;
  private _backup: {[id: number]: any} = {};

  constructor(private data: DataService, private title: Title) {}

  ngOnInit() {
    this.title.setTitle('Estados de Planilla | Sistema');
    this.GetData();
  }

  GetData() {
    this.loading.show('Cargando...');
    this.items = [];
    const req = this.search
      ? this.data.GetFromValue(this.data.api.estado_planilla, 'nombre__icontains', this.search)
      : this.data.GetSimple(this.data.api.estado_planilla);
    req.subscribe(
      r => { this.loading.hide(); this.items = r; this.total = r.length; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowNew()   { this.nuevo = new EstadoPlanilla(); this.agregando = true; }
  CancelNew() { this.agregando = false; this.nuevo = new EstadoPlanilla(); }
  formNewValid(): boolean { return !!(this.nuevo.codigo && this.nuevo.nombre); }

  SaveNew() {
    this.loading.show('Registrando...');
    this.data.Post(this.data.api.estado_planilla, this.nuevo).subscribe(
      r => { this.loading.hide(); this.agregando = false; this.nuevo = new EstadoPlanilla(); this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  StartEdit(item: EstadoPlanilla)  { this._backup[item.idestado] = { ...item }; item.editando = true; }
  CancelEdit(item: EstadoPlanilla) { Object.assign(item, this._backup[item.idestado]); item.editando = false; }

  SaveEdit(item: EstadoPlanilla) {
    this.loading.show('Actualizando...');
    this.data.Put(this.data.api.estado_planilla, `${item.idestado}`, item).subscribe(
      r => { this.loading.hide(); item.editando = false; delete this._backup[item.idestado]; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowDelete(item: EstadoPlanilla) {
    this.info.show(`¿Deseas eliminar el estado "${item.nombre}"?`, 1, null,
      { cancelText: 'No, Cancelar', successText: 'Sí, Eliminar', isCancel: true },
      () => this.Delete(item), () => { this.info.hide(); }, 20);
  }

  Delete(item: EstadoPlanilla) {
    this.loading.show('Eliminando...');
    this.data.Delete(this.data.api.estado_planilla, `${item.idestado}`).subscribe(
      r => { this.loading.hide(); this.info.show(r.message, 2, null, null, () => { this.info.hide(); this.GetData(); }); },
      e => { this.loading.hide(); this.info.error(e, () => this.info.hide()); }
    );
  }
}
